/**
 * Convert a dataId selector into a error id
 * @param {string} dataId
 * @returns {string}
 */
export const getErrorIdFromDataId = (dataId = ""): string => {
	const isAlpha = /^[a-zA-Z]+$/;
	const [dataIdWithoutSuffix = ""] = dataId?.split("-error");
	const chars = dataIdWithoutSuffix.toUpperCase().split("");

	let id = "";

	for (const char of chars) {
		if (isAlpha.test(char)) id += char;

		if (char === "-") id += "_";
	}

	return id;
};
